import $http from "./http";

//获取安装列表
export const getPointList = data => {
    return $http.post("/collect/point_design/getPointList", data);
};

//获取采集点信息
export const getInfoById = data => {
    return $http.post("/collect/point_design/getInfoById", data);
};

//采集点保存
export const savePointDesign = data => {
    return $http.post("/collect/point_design/save", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//采集点删除
export const delPointDesign = data => {
    return $http.post("/collect/point_design/del", data);
};

//获得采集单元下拉
export const getDocId = data => {
    return $http.post("/collect/point_design/getDocList", data);
};

//获得户号下拉
export const getAccountList = data => {
    return $http.post("/collect/point_design/getAccountList", data);
};

//获得采集点类型
export const getPointClassList = data => {
    return $http.post("/collect/common/getPointClassList", data);
};

export const getPointClassListNew = data => {
    return $http.post("/collect/target_unit/getTargetPointClassList", data);
};

//获得反向采集点列表
export const getFPointList = data => {
    return $http.post("/collect/point_design/getFPointList", data);
};

//获得反向采集点列表
export const getBWGPointList = data => {
    return $http.post("/collect/point_design/getPointListByPointClassId", data);
};